import { j as r } from "../../_virtual/jsx-runtime.js";
const H = ({
  width: t = 20,
  height: C = 20,
  viewBox: o = "0 0 20 20",
  fill: s = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: t,
    height: C,
    viewBox: o,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M18.3333 9.16666V16.6667H16.6667V13.3333H3.33334V16.6667H1.66667V3.33333H3.33334V11.6667H10V5.83333H15C16.8409 5.83333 18.3333 7.32571 18.3333 9.16666ZM16.6667 11.6667V9.16666C16.6667 8.24619 15.9205 7.49999 15 7.49999H11.6667V11.6667H16.6667ZM6.66667 9.16666C7.1269 9.16666 7.5 8.79358 7.5 8.33333C7.5 7.87309 7.1269 7.49999 6.66667 7.49999C6.20644 7.49999 5.83334 7.87309 5.83334 8.33333C5.83334 8.79358 6.20644 9.16666 6.66667 9.16666ZM6.66667 10.8333C5.28596 10.8333 4.16667 9.71408 4.16667 8.33333C4.16667 6.95262 5.28596 5.83333 6.66667 5.83333C8.04738 5.83333 9.16667 6.95262 9.16667 8.33333C9.16667 9.71408 8.04738 10.8333 6.66667 10.8333Z",
        fill: s
      }
    )
  }
);
export {
  H as default
};
